export default "__VITE_ASSET__DWlthWYJ__"